module.exports = __webpack_public_path__ + "static/assets/6d138bac87fd7285b31f7a687ea5eac1.svg";